import {whitelabelling as Whitelabelling} from 'whitelabelling';
import {AffinityGroupCategories as CategoriesCollection} from 'collection/affinityGroupCategories';
import {AffinityGroups as GroupsCollection} from 'collection/affinityGroups';
import {Education} from 'model/education';
import {School} from 'model/school';

const customInputSectionEditProfile = 'edit_profile_custom';
const customInputSectionRegistrationOnly = 'registration_only';

// For checking if the user changes their email mid-registration.
let oldEmail = null;

export const PersonalInfoGroupStepController = [
    '$scope', '$http', '$q', 'CustomInputService',
    function($scope, $http, $q, CustomInputService) {
        $scope.groupName = 'Personal Info';
        $scope.withHero = false; // should we show a hero section
        $scope.autoAdvance = false; // if true, next-step button is auto-clicked
        $scope.finalStep = 10; // the last step number of this group, by default. Can be overridden.
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/stepGroups/personalInfo.html';
        $scope.whitelabelling = Whitelabelling;
        $scope.displayPhoneField = !Whitelabelling.settings['hide:mentoringRelatedFeatures'];
        $scope.adminCanChange = true;
        $scope.userCanChange = true;
        $scope.isAdmin = false;

        // Handle an 11th step for customInputs of the edit_profile_custom_section.
        if ($scope.customInputs.sections[customInputSectionEditProfile]) {
            if (!($scope.registrationData.primaryRole === 'expert' && $scope.whitelabelling.settings['registrationSkipCustomInputsForExpert'])) {
                $scope.hasCustomSection = CustomInputService.hasEditProfileCustomSection();
                $scope.registrationData = CustomInputService.mergeCustomInputPlaceholdersIntoRegistrationData($scope.registrationData);
                $scope.finalStep = 11;
            }
        }

        if ($scope.customInputs.sections[customInputSectionRegistrationOnly]) {
            if (!($scope.registrationData.primaryRole === 'expert' && $scope.whitelabelling.settings['registrationSkipCustomInputsForExpert'])) {
                $scope.registrationData = CustomInputService.mergeCustomInputPlaceholdersIntoRegistrationData($scope.registrationData);
                $scope.finalStep = 12;
            }
        }

        // if the localStep is -1, we need to go to the very last step
        if ($scope.localStep === -1) {
            $scope.localStep = $scope.finalStep;
        }

        $scope.graduationDateStep = function() {
            if (!Whitelabelling.affiliatedSchool) {
                $scope.skipThisStep();
                return false;
            }
            if ($scope.registrationData.primaryRole === 'consumer'
                && $scope.registrationSettings.WhitelabelSettings['registrationHideGraduationStepForConsumer']) {
                $scope.skipThisStep();
                return false;
            }
            if ($scope.registrationData.primaryRole === 'expert'
                && $scope.registrationSettings.WhitelabelSettings['registrationHideGraduationStepForExpert']) {
                $scope.skipThisStep();
                return false;
            }
            switch ($scope.localSubStep) {
                case 0:
                    $scope.$watch('registrationData.dateGraduated', function() {
                        // we can show next the next button if we have a date
                        $scope._basicShowNextCondition();
                    });

                    $scope.hasErrors = function() {
                        var errors = $scope.registrationData.validateData();
                        return errors.dateGraduated;
                    };

                    if ($scope.registrationData.primaryRole === 'expert'
                        && $scope.registrationSettings.WhitelabelSettings['registrationHideGraduationDateForExpert']) {
                        $scope.goToNextSubStep();
                    }

                    break;
                case 1:
                case 2:
                    $scope.registrationData.set('dateGraduated', null);
                    $scope.$watch('registrationData.platformAffiliation', function() {
                        // we can show next the next button if we have a date
                        $scope._basicShowNextCondition();
                    });

                    $scope.hasErrors = function() {
                        var errors = $scope.registrationData.validateData();
                        return errors.platformAffiliation;
                    };

                    $scope.autoAdvance = !$scope.registrationData.platformAffiliation;
                    break;
            }

        };

        $scope.degreeStep = function() {
            if ($scope.registrationSettings.WhitelabelSettings['hideField:personalInfo_userInputEducation']) {
                $scope.skipThisStep();
                return false;
            }

            if ($scope.registrationData.primaryRole === 'consumer'
                && $scope.registrationSettings.WhitelabelSettings['registrationHideDegreeStepForConsumer']) {
                $scope.skipThisStep();
                return false;
            }

            if (!$scope.whitelabelling.affiliatedSchool &&
                !$scope.registrationSettings.WhitelabelSettings.forceCollectConsumerEducation) {
                $scope.skipThisStep();
                return false;
            }
            $scope.$on('skipThisStep', function() {
                $scope.skipThisStep();
            });

            $scope.assumeSameSchool = true;
            if ($scope.registrationData.get('dateGraduated') && $scope.whitelabelling.affiliatedSchool) {
                $scope.foundRelevantEducation = $scope.registrationData.Education.findWhere(function(e) {
                    return e.get('School').get('id') === $scope.whitelabelling.affiliatedSchool.id;
                });
                if (!$scope.foundRelevantEducation) {
                    // No preexisting degree was entered; we created the record now.
                    $scope.foundRelevantEducation = new Education({
                        School: new School($scope.whitelabelling.affiliatedSchool, {parse: true}),
                        dateGraduated: $scope.registrationData.get('dateGraduated'),
                    }, {parse: true});
                    $scope.registrationData.Education.add($scope.foundRelevantEducation);
                } else if ($scope.foundRelevantEducation && $scope.foundRelevantEducation.dateGraduated !==
                    $scope.registrationData.get('dateGraduated')) {
                    // The user went back and changed their grad date...
                    $scope.foundRelevantEducation.dateGraduated = $scope.registrationData.get('dateGraduated');
                }

                // now we check to make sure they've entered valid information to proceed
                $scope.$watchCollection('foundRelevantEducation.errors', function() {
                    $scope._basicShowNextCondition();
                });

                $scope.hasErrors = function() {
                    if (!$scope.foundRelevantEducation) {
                        return false;
                    } else {
                        var errors = $scope.foundRelevantEducation.validateData();
                        return errors.Degree || errors.Concentrations;
                    }
                };
            } else if ($scope.registrationData.primaryRole !== 'consumer' ||
                !$scope.registrationSettings.WhitelabelSettings.forceCollectConsumerEducation) {
                // if they don't have a graduation date, then they're probably not a student so we don't ask them
                // about their degrees at this time
                $scope.skipThisStep();
            } else if ($scope.registrationData.primaryRole === 'consumer') {
                // Basically: An advisee on a Whitelabel without a school, but which has
                // forceCollectConsumerEducation.
                $scope.assumeSameSchool = false;
                if (!$scope.registrationData.Education.length && !$scope.registrationData.userSetDoesNotHaveDegree) {
                    $scope.registrationData.Education.add(new Education({}, {parse: true}));
                }
                $scope.$watch(function() {
                    return $scope.registrationData.get('Education').isComplete();
                }, function(newVal) {
                    $scope.showNext = newVal;
                });
            }
        };

        $scope.affinityGroupStep = function() {
            if ($scope.registrationSettings.WhitelabelSettings['hideField:personalInfo_userInputAffinityGroups']) {
                $scope.skipThisStep();
                return false;
            }

            /**
             * This is a little hacky. Let me explain:
             * The template doesn't know how many sub steps it will have (could be up to 8, could be none at all)
             * So what we do is quickly calculate how many there should be and if we're beyond that, we go to the
             * next step If we're not beyond that, we determine which category(ies) to select groups from based on
             * the localSubStep number as it relates to the list of requiredCategories (+ or the optional catch all
             * for non-required categories) This substep order is stored in requiredCategories which will then pass
             * which category we're inputting on to the affinity-input directive
             */
            if ($scope.registrationSettings.AffinityGroupCategories.length) {
                $scope.requiredCategories = new CategoriesCollection(
                    $scope.registrationSettings.AffinityGroupCategories.where({'isRequired': true}));
                $scope.hasNotRequiredCategories = false;

                // if the number of requires categories is strictly less than the number, we know there are some
                // that are not required
                if ($scope.requiredCategories.length < $scope.registrationSettings.AffinityGroupCategories.length) {
                    $scope.hasNotRequiredCategories = true;
                    $scope.notRequiredCategories = new CategoriesCollection(
                        $scope.registrationSettings.AffinityGroupCategories.where({'isRequired': false}));
                }

                // now we determine how many steps we need in total to complete this section...
                var numberOfAffinityGroupSteps = $scope.requiredCategories.length +
                    ($scope.hasNotRequiredCategories ? 1 : 0);

                // if we've passed the total needed, we must have gotten them all
                if ($scope.localSubStep >= numberOfAffinityGroupSteps) {
                    // we're done if we've sub-stepped beyond the number of affinity group input steps
                    // NOTE: this should not be a Skip step, it must be goToNext
                    $scope.goToNextStep();
                    return true;
                }

                // next, we determine what data we should pass to the input directive based on what sub step we're
                // on and hwo many (if any) required categories we need to answer individually
                if ($scope.localSubStep < $scope.requiredCategories.length) {
                    $scope.showAlsoText = false;
                    $scope.categoriesToChooseFrom = new CategoriesCollection(
                        $scope.requiredCategories.at($scope.localSubStep));
                } else if ($scope.hasNotRequiredCategories) {
                    // we only show also text if it's a not-required category selection that is also not the first
                    // substep
                    $scope.showAlsoText = $scope.localSubStep !== 0;

                    $scope.categoriesToChooseFrom = $scope.notRequiredCategories;
                } else {
                    $scope.goToNextStep();
                    return true;
                }

                // merge all the groups from all categories together
                var allGroups = new GroupsCollection();
                $scope.categoriesToChooseFrom.each(function(c) {
                    allGroups.add(c.get('AffinityGroups').models);
                });

                // make sure we've selected at least one from the groups we're showing before showing the next
                // button
                $scope.$watch('registrationData.AffinityGroups.length', function() {
                    // if we're selecting not-required groups, we always show the next button
                    if ($scope.categoriesToChooseFrom === $scope.notRequiredCategories) {
                        $scope.showNext = true;
                    } else {
                        $scope._basicShowNextCondition();
                    }
                });

                $scope.hasErrors = function() {
                    var relevantGroups = $scope.registrationData.AffinityGroups.where(function(g) {
                        return !!allGroups.get(g.get('id'));
                    });

                    if (relevantGroups.length === 0) {
                        return true;
                    }
                };
                // start off with an input check
                $scope._basicShowNextCondition();

            } else {
                // we have no groups (because we have no active categories) so we skip this step
                $scope.skipThisStep();
                return false;
            }

            // in this section we only navigate by substeps
            $scope.goToNextStep = $scope.goToNextSubStep;
        };

        $scope.genderStep = function() {
            if ($scope.registrationSettings.WhitelabelSettings['hideField:gender']) {
                $scope.skipThisStep();
                return false;
            }

            $scope.customGenders = $scope.registrationSettings.WhitelabelSettings['customized:gender'];

            $scope.$watch('registrationData.User.gender', function() {
                // we can show next the next button if we have a gender
                $scope._basicShowNextCondition();
            });
            $scope.autoAdvance = !$scope.registrationData.User.get('gender');

            $scope.hasErrors = function() {
                var errors = $scope.registrationData.get('User').validateData();
                return errors.gender;
            };
        };

        $scope.raceStep = function() {
            if ($scope.registrationSettings.WhitelabelSettings['hideField:race']) {
                $scope.skipThisStep();
                return false;
            }

            $scope.customRaces = $scope.registrationSettings.WhitelabelSettings['customized:race'];

            $scope.$watch('registrationData.User.race', function() {
                // we can show next the next button if we have a race
                $scope._basicShowNextCondition();
            });
            $scope.autoAdvance = !$scope.registrationData.User.get('race');

            $scope.hasErrors = function() {
                return !$scope.registrationData.get('User').get('race');
            };
            return false;
        };

        $scope.languagesStep = function() {
            if ($scope.registrationData.Programs.some(program => program.id === 144)) {
                $scope.skipThisStep();
            }

            if ($scope.registrationSettings.WhitelabelSettings['hideField:personalInfo_userInputLanguage']) {
                $scope.skipThisStep();
                return false;
            }

            $scope.$watch('registrationData.Languages.length', function() {
                // we can show next the next button if we have at least 1 language
                $scope._basicShowNextCondition();
            });

            $scope.hasErrors = function() {
                var errors = $scope.registrationData.validateData();
                return errors.Languages;
            };
            return false;
        };

        const addCustomInputListener = () => {
            $scope.$on('CustomInputChanged', function(evt, customInput, newData) {
                customInput.markNotPristine();
                $scope.customInputs.validate(customInput, newData);
                $scope.hasErrors();
                $scope._basicShowNextCondition();
            });
        };

        $scope.customInputStep = function() {
            if (!$scope.customInputs.sections[customInputSectionEditProfile]) {
                $scope.skipThisStep();
                return;
            }
            if ($scope.localSubStep >= $scope.customInputs.sections[customInputSectionEditProfile].inputs.length) {
                $scope.goToNextStep();
                return;
            }
            if ($scope.localSubStep < $scope.customInputs.sections[customInputSectionEditProfile].inputs.length - 1) {
                $scope.goToNextStep = $scope.goToNextSubStep;
            }
            if (
                $scope.registrationData.Programs.some(program => program.id === 144) &&
                $scope.customInputs.sections[customInputSectionEditProfile].inputs[$scope.localSubStep].type === 'multipleChoice' &&
                (
                    $scope.customInputs.sections[customInputSectionEditProfile].inputs[$scope.localSubStep].id === 3 ||
                    $scope.customInputs.sections[customInputSectionEditProfile].inputs[$scope.localSubStep].id === 4
                )
            ) {
                $scope.goToNextStep();
            }

            addCustomInputListener();

            $scope.hasErrors = function() {
                return ($scope.customInputs.requiresInput(customInputSectionEditProfile,
                    $scope.registrationData.CustomInputs, $scope.localSubStep) ||
                    !$scope.customInputs.isValid(customInputSectionEditProfile, $scope.localSubStep));
            };

            // Initialize hasErrors...
            $scope.hasErrors();
            $scope._basicShowNextCondition();
        };

        $scope.customInputStepRegistrationOnlySection = function() {
            if (!$scope.customInputs.sections[customInputSectionRegistrationOnly]) {
                $scope.skipThisStep();
                return;
            }
            if ($scope.localSubStep >= $scope.customInputs.sections[customInputSectionRegistrationOnly].inputs.length) {
                $scope.goToNextStep();
                return;
            }
            if ($scope.localSubStep < $scope.customInputs.sections[customInputSectionRegistrationOnly].inputs.length - 1) {
                $scope.goToNextStep = $scope.goToNextSubStep;
            }

            addCustomInputListener();

            $scope.hasErrors = function() {
                return ($scope.customInputs.requiresInput(customInputSectionRegistrationOnly,
                    $scope.registrationData.CustomInputs, $scope.localSubStep) ||
                    !$scope.customInputs.isValid(customInputSectionRegistrationOnly, $scope.localSubStep));
            };

            // Initialize hasErrors...
            $scope.hasErrors();
            $scope._basicShowNextCondition();
        };

        $scope.degreeStepForWhenGraduationDateNotGiven = function() {
            $scope.foundRelevantEducation = new Education({
                School: new School($scope.whitelabelling.affiliatedSchool, {parse: true}),
                dateGraduated: new Date(),
            }, {parse: true});
            $scope.registrationData.Education.add($scope.foundRelevantEducation);

            $scope.$watchCollection('foundRelevantEducation.errors', function() {
                $scope._basicShowNextCondition();
            });

            $scope.hasErrors = function() {
                if (!$scope.foundRelevantEducation) {
                    return false;
                } else {
                    var errors = $scope.foundRelevantEducation.validateData();
                    return errors.Degree || errors.Concentrations;
                }
            };
            return false;
        };

        const stepsForMcMasterAfterStep4 = [
            $scope.customInputStep,
            $scope.degreeStepForWhenGraduationDateNotGiven,
            $scope.graduationDateStep,
            $scope.affinityGroupStep,
            $scope.genderStep,
            $scope.raceStep,
            $scope.languagesStep,
        ];

        const defaultStepsAfterStep4 = [
            $scope.graduationDateStep,
            $scope.degreeStep,
            $scope.affinityGroupStep,
            $scope.genderStep,
            $scope.raceStep,
            $scope.languagesStep,
            $scope.customInputStep,
            $scope.customInputStepRegistrationOnlySection,
        ];

        $scope.stepsAfterStep4 = ($scope.whitelabelling.id === 273)
            ? stepsForMcMasterAfterStep4
            : defaultStepsAfterStep4;

        let errors = false;

        // here we determine what the data criteria is before we show the Next button
        switch ($scope.localStep) {
            case 0:
                if (!$scope.canChoosePrimaryRole) {
                    $scope.hideNav = true;
                }

                $scope.$watch('registrationData.User.fullName', function() {
                    // we can show next the next button
                    $scope._basicShowNextCondition();
                });

                $scope.hasErrors = function() {
                    const errors = $scope.registrationData.get('User').validateData();
                    return errors.firstName || errors.lastName;
                };
                break;
            case 1:
                $scope.user = $scope.registrationData.get('User');

                $scope.hasErrors = () => {
                    const errors = $scope.user.validateData();
                    return errors.email || errors.phone;
                }

                $scope.$watch('user.email', () =>{
                    // Input directive will validate. Just check if we have a value.
                    $scope.registrationSettings.set('loginError', false);
                    $scope.registrationSettings.set('maskError', false);
                    $scope.generalError = undefined;
                    $scope._basicShowNextCondition();

                })

                $scope.$watch('user.phone', () => {
                    $scope._basicShowNextCondition();
                }, true);

                break;
            case 2:
                if (!$scope.registrationData.User.get('selfRegistered')) {

                    if (oldEmail === null) {
                        oldEmail = $scope.registrationData.User.email;
                    }

                    if (($scope.registrationSettings.WhitelabelSettings['useSSO']
                            && ($scope.registrationData.User.id && (oldEmail === $scope.registrationData.User.email)))
                        || $scope.showPasswordInput === false) {
                        $scope.skipThisStep();
                        break;
                    }
                    $scope.$watch('registrationData.User.password', function() {
                        // Input directive will validate. Just check if we have a value.
                        $scope._basicShowNextCondition();
                    });

                    $scope.hasErrors = function() {
                        var password = $scope.registrationData.get('User').password;
                        return !(password && password.length >= 8);
                    };

                    var oldGoToNext = $scope.goToNextStep;

                    $scope.goToNextStep = function() {
                        $q.when($scope.registrationData.save()).then(function() {
                            if ($scope.registrationData.User && $scope.registrationData.User.saveErrors &&
                                $scope.registrationData.User.saveErrors.emailCollision) {
                                // A successful submission -- but the email address failed to update.
                                return $scope.registrationSettings.set('loginError', true);
                            } else {
                                // it worked, invoke the old go to next function
                                oldEmail = $scope.registrationData.User.email;
                                oldGoToNext.call($scope);
                            }
                        }, function(responseObj) {
                            var data = JSON.parse(responseObj.responseText);
                            // it didn't work, check status code
                            if (data.status === 401) {
                                // bad login credentials
                                if (data.error === 'Incorrect credentials') {
                                    return $scope.registrationSettings.set('loginError', true);
                                } else if (data.error === 'Email mask error') {
                                    return $scope.registrationSettings.set('maskError', true);
                                }
                            }

                            $scope.generalError = data.error;
                        });
                    };
                } else {
                    $scope.skipThisStep();
                }

                break;
            case 3:
                if (!Whitelabelling.settings['hideField:location']) {
                    $scope.$watch('registrationData.User.currentLocation', function() {
                        // we can show next the next button if we have a label and placeid
                        $scope._basicShowNextCondition();
                    });

                    $scope.hasErrors = function() {
                        return $scope.registrationData.get('User').validateData().currentLocation;
                    };
                } else {
                    $scope.skipThisStep();
                }

                break;

            case 4:
                if (!Whitelabelling.settings['hideField:avatar']) {
                    $scope.$watch('registrationData.User.avatarURL', function() {
                        // we can show next the next button if we have a picture url
                        $scope._basicShowNextCondition();
                    });

                    $scope.hasErrors = function() {
                        var errors = $scope.registrationData.get('User').validateData();
                        return errors.avatarURL;
                    };
                } else {
                    $scope.skipThisStep();
                }

                break;

            case 5:
                errors = $scope.stepsAfterStep4[0]();
                if (errors !== false) {
                    return errors;
                }
                break;

            case 6:
                errors = $scope.stepsAfterStep4[1]();
                if (errors !== false) {
                    return errors;
                }
                break;

            case 7:
                errors = $scope.stepsAfterStep4[2]();
                if (errors !== false) {
                    return errors;
                }
                break;

            case 8:
                errors = $scope.stepsAfterStep4[3]();
                if (errors !== false) {
                    return errors;
                }
                break;

            case 9:
                errors = $scope.stepsAfterStep4[4]();
                if (errors !== false) {
                    return errors;
                }
                break;

            case 10:
                errors = $scope.stepsAfterStep4[5]();
                if (errors !== false) {
                    return errors;
                }
                break;

            case 11:
                errors = $scope.stepsAfterStep4[6]();
                if (errors !== false) {
                    return errors;
                }
                break;
            case 12:
                errors = $scope.stepsAfterStep4[7]();
                if (errors !== false) {
                    return errors;
                }
                break;
        }

        $scope.sendPasswordReset = function() {
            $scope.showResetSentMessage = true;
            $http({
                url: '/account/password/reset/request',
                method: 'POST',
                data: $.param({email: $scope.registrationData.User.email}),
                headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
            });
        };
    },
];
